import React, { useEffect, useState } from "react";
import { Button } from "@nextui-org/react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Notification from "../Notification/Notification";

const Header = () => {
    const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const { _orgId } = useParams();

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    // Update time every minute
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);





  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div>
      <div className="flex h-[60px] items-center justify-between border-b border-neutral-200 px-6 bg-white">
        {/* Left side - Time */}
        <div className="flex items-center gap-6">
          <div>
            <p className="text-xs text-neutral-600 font-medium">
              {formatTime(currentTime)} • {formatDate(currentTime)}
            </p>
          </div>
        </div>

        {/* Right side - Actions */}
        <div className="flex flex-row items-center gap-4">
          {/* Notification */}
          <span className="flex h-8 items-center gap-2 rounded-md px-2 text-sm text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 cursor-pointer transition-colors">
            <Notification />
          </span>

          
        </div>
      </div>
    </div>
  );
};

export default Header;